import '../node_modules/core-js/modules/es.string.trim.js';
import { tz } from 'moment-timezone';
import { COUNTRIES } from '../constants/countries.js';

function getUserAlpha2(alpha2Codes) {
  const timezone = tz.guess(true);
  return alpha2Codes.find(code => tz.zonesForCountry(code).some(countryTimezone => countryTimezone.trim() == timezone.trim()));
}

/**
 * This function retrieves the alpha-2 country code from the given phone code.
 * @param alpha2Codes - An array of alpha-2 country codes.
 * @param phoneCode - The phone code to search for.
 */
function getAlpha2FromPhoneCode(alpha2Codes, phoneCode) {
  return alpha2Codes.find(alpha2 => COUNTRIES[alpha2].phoneCode === phoneCode);
}

export { getAlpha2FromPhoneCode, getUserAlpha2 };
